<template>
  <div>
    <form ref="form" method="post" class="login-pwd-reset">
      <div class="input-unit" data-validate="mail">
        <input
          type="email"
          name="email"
          autocomplete="email"
          data-testing="guest-login-input"
          :id="_uid"
          :placeholder="multiLanguage.LoginEmailPlaceholder"
          v-model="email"
          data-autofocus
        />
        <label :for="_uid">
          {{ $translate("Ceres::Template.loginEmail") }}*
        </label>
      </div>
      <span class="error-msg">
        {{ $translate("Ceres::Template.loginEnterConfirmEmail") }}
      </span>

      <div class="form-check small my-3" data-validate>
        <input
          type="checkbox"
          class="form-check-input"
          id="privacy-policy-accept"
          name="privacy-policy-accept"
          v-model="privacyPolicyValue"
          data-testing="nl-policy"
          aria-label="checkbox"
        />
        <label
          for="privacy-policy-accept"
          class="form-check-label"
          v-html="privacyPolicyText"
        >
        </label>
      </div>

      <div class="mt-3">
        <button
          @click.prevent="validate"
          :disabled="isDisabled"
          class="w-100 btn btn-primary btn-medium btn-appearance"
          data-testing="guest-login-button"
        >
          {{ $translate("Ceres::Template.loginNext") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";
import AutoFocusService from "../../../services/AutoFocusService";
import ValidationService from "../../../services/ValidationService";
import { navigateTo } from "../../../services/UrlService";
import { isDefined, isNullOrUndefined } from "../../../helper/utils";
import ModalService from "../../../services/ModalService";

export default {
  props: {
    backlink: {
      type: String,
    },
    initialEmail: {
      type: String,
      default: "",
    },
    multiLanguage: Object,
  },

  data() {
    return {
      email: "",
      privacyPolicyValue: false,
      isDisabled: false,
    };
  },
  computed: {
    privacyPolicyText() {
      const link =
        '<a href="' +
        App.urls.privacyPolicy +
        '" target="_blank"><span class="text-appearance">' +
        this.$translate("Ceres::Template.checkoutPrivacyPolicy", {
          hyphen: "&shy;",
        }) +
        "</span></a>";
      return (
        this.$translate("Ceres::Template.newsletterAcceptPrivacyPolicy", {
          policy: link,
        }) + this.$translate("Ceres::Template.newsletterIsRequiredFootnote")
      );
    },
  },

  created() {
    if (!isNullOrUndefined(this.initialEmail) && this.initialEmail.length > 0) {
      this.email = this.initialEmail;
    }
  },

  mounted() {
    this.$nextTick(() => {
      const modal = ModalService.findModal(this.$parent.$refs.guestModal);

      if (!isNullOrUndefined(modal)) {
        modal.on("hidden.bs.modal", () => {
          this.email = "";
          ValidationService.unmarkAllFields(this.$refs.form);
        });
      }

      if (isDefined(modal)) {
        modal.on("shown.bs.modal", () => {
          AutoFocusService.triggerAutoFocus(modal);
        });
      }
    });
  },

  methods: {
    validate() {
      ValidationService.validate(this.$refs.form)
        .done(() => {
          this.authGuest();
        })
        .fail((invalidFields) => {
          ValidationService.markInvalidFields(invalidFields, "error");
        });
    },

    authGuest() {
      this.isDisabled = true;

      ApiService.post("/rest/io/guest", { email: this.email })
        .done(() => {
          navigateTo(
            isDefined(this.backlink) && this.backlink.length
              ? decodeURIComponent(this.backlink)
              : window.location.origin +
                  (App.urls.includeLanguage ? "/" + App.language : "")
          );
        })
        .fail(() => {
          this.isDisabled = false;
        });
    },
  },
};
</script>
